import { createRoot } from "react-dom/client";
import { LanguageProvider } from './contexts/LanguageContext';
import App from "./App.tsx";
import "./index.css";
import { initGA } from './config/analytics';
import { performanceMonitor, markPerformance, measurePerformance } from "./lib/performance";

// Mark app initialization start
markPerformance('app-init-start');

createRoot(document.getElementById("root")!).render(
  <LanguageProvider>
    <App />
  </LanguageProvider>
);

// Measure app initialization time
markPerformance('app-init-end');
measurePerformance('app-initialization', 'app-init-start', 'app-init-end');

// Start tracking Core Web Vitals
performanceMonitor.getCoreWebVitals();

// Initialize Google Analytics with lazy loading (after initial render)
// This will load GA on first user interaction or after 5 seconds
initGA();
